{
  "login": {
    "title": "Iniciar sesión",
    "subtitle": "Bienvenido de nuevo a ForumOne",
    "welcomeEmailHint": "Use la contraseña temporal de su correo de bienvenida para iniciar sesión.",
    "noAccount": "¿No tiene una cuenta?",
    "signUpLink": "Registrarse",
    "email": "Correo electrónico",
    "identifier": "Correo, nombre de usuario o teléfono",
    "identifierPlaceholder": "Correo, nombre de usuario o número de teléfono",
    "password": "Contraseña",
    "forgotPassword": "¿Olvidó su contraseña?",
    "submit": "Iniciar sesión",
    "submitting": "Iniciando sesión...",
    "welcomeBack": "Bienvenido de nuevo, {{name}}",
    "failed": "Error al iniciar sesión"
  },
  "signup": {
    "title": "Registrarse",
    "subtitle": "Cree su cuenta de negocio o institución",
    "hasAccount": "¿Ya tiene una cuenta?",
    "signInLink": "Iniciar sesión",
    "fullName": "Nombre completo",
    "phone": "Número de teléfono",
    "username": "Nombre de usuario (opcional)",
    "usernamePlaceholder": "Elija un nombre de usuario",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "namePlaceholder": "Nombre",
    "phonePlaceholder": "Teléfono",
    "emailPlaceholder": "correo",
    "passwordPlaceholder": "contraseña",
    "submit": "Crear una cuenta",
    "submitting": "Creando cuenta...",
    "accountCreated": "Cuenta creada correctamente"
  },
  "resetPassword": {
    "documentTitle": "Restablecer contraseña",
    "enterEmail": {
      "title": "Ingresar correo",
      "subtitle": "Se enviará un código de verificación a su correo electrónico"
    },
    "verifyEmail": {
      "title": "Verificar correo",
      "subtitle": "Se ha enviado un código de verificación a",
      "fallbackEmail": "su correo electrónico"
    },
    "newPassword": {
      "title": "Restablecer contraseña",
      "subtitle": "Se enviará un código de verificación a su correo. Ingrese el código y su nueva contraseña."
    },
    "fields": {
      "email": {
        "label": "Correo electrónico",
        "placeholder": "Correo electrónico"
      },
      "verificationCode": {
        "label": "Código de verificación",
        "placeholder": "Código"
      },
      "newPassword": {
        "label": "Nueva contraseña",
        "placeholder": "Nueva contraseña"
      },
      "confirmNewPassword": {
        "label": "Confirmar contraseña",
        "placeholder": "Confirmar contraseña"
      }
    },
    "sendEmail": "Enviar correo",
    "retrieving": "recuperando...",
    "verify": "Verificar",
    "verifying": "verificando...",
    "backToLogin": "Volver al inicio de sesión",
    "toast": {
      "emailSent": "Correo enviado correctamente",
      "requestFailed": "Error al restablecer la contraseña",
      "sendEmailFailed": "Error al enviar el correo",
      "resetSuccess": "Contraseña restablecida correctamente",
      "duplicateEntry": "Entrada duplicada encontrada",
      "accountVerified": "Cuenta verificada correctamente",
      "verifyFailed": "Error al verificar el código"
    }
  },
  "selectBusiness": {
    "documentTitle": "Seleccionar negocio o institución",
    "title": "Gestione sus negocios e instituciones en un solo lugar",
    "subtitle": "Seleccione un negocio o institución para comenzar, o cree uno nuevo para ampliar su presencia.",
    "fallbackBusinessName": "Negocio o institución",
    "noDescription": "Sin descripción",
    "chooseLocation": "Elija una ubicación para continuar",
    "createCard": {
      "title": "Crear nuevo negocio o institución",
      "description": "Agregue otro negocio o institución a su cuenta"
    }
  },
  "selectConsoleScope": {
    "documentTitle": "Elegir espacio de trabajo",
    "title": "¿A dónde le gustaría ir?",
    "subtitle": "Tiene acceso a la consola de administración y a las herramientas de negocio o institución. Recordaremos su elección para la próxima vez.",
    "adminCard": {
      "title": "Consola de administración",
      "description": "Gestione todos los negocios e instituciones y la configuración de la plataforma.",
      "cta": "Continuar como administrador"
    },
    "tenantCard": {
      "title": "Mi negocio o institución",
      "description": "Panel, servicios, citas y herramientas del equipo.",
      "cta": "Continuar al negocio o institución"
    },
    "toast": {
      "preferenceSaveError": "No se pudo guardar la preferencia. Inténtelo de nuevo."
    }
  },
  "linkBusinessOwner": {
    "documentTitle": "Vincular cuenta de negocio o institución",
    "title": "La cuenta ya existe",
    "subtitlePrefix": "Este correo ya está registrado. Si un administrador creó su perfil de negocio, use la contraseña temporal de su correo de bienvenida e",
    "signInLink": "inicie sesión",
    "subtitleSuffix": "en lugar de registrarse de nuevo.",
    "secondaryHint": {
      "prefix": "De lo contrario, ingrese su contraseña existente a continuación para agregar acceso de",
      "role": "propietario de negocio o institución",
      "suffix": "al mismo inicio de sesión."
    },
    "emailLabel": "Correo electrónico",
    "nameOnSignupLabel": "Nombre al registrarse",
    "passwordLabel": "Contraseña",
    "passwordPlaceholder": "Su contraseña existente",
    "submit": "Continuar",
    "submitting": "Verificando...",
    "wrongEmail": "¿Correo incorrecto?",
    "backToSignup": "Volver al registro",
    "toast": {
      "startFromSignup": "Comience desde el registro con su correo.",
      "linkedOwnerAccess": "Acceso de propietario de negocio o institución vinculado a su cuenta",
      "linkedVerifyEmail": "Vinculado — ingrese el código de verificación enviado a su correo",
      "linkError": "No se pudo vincular la cuenta"
    }
  },
  "common": {
    "or": "o",
    "termsPrefix": "Al hacer clic en continuar, acepta nuestros",
    "termsOfService": "Términos de servicio",
    "and": "y",
    "privacyPolicy": "Política de privacidad"
  }
}
